import { useHistory, useRouteMatch } from 'react-router';

import { ATSPrincipalAppNavbarTestIds } from 'data-testids/ATS';
import { Box, useTheme } from '@mui/material';
import { NavbarContainer } from '../styles';
import { TextButton } from 'sharedComponents/Buttons';
import { UserDropdownMenu } from './UserDropdownMenu';
import logo from '../assets/logo.jpg';
import auth from 'utils/auth';

export const PrincipalDesktopNavigation = () => {
  const history = useHistory();
  const theme = useTheme();

  const handleCandidatesClick = () => history.push('/principal/candidates');

  const handleHiringRequestsClick = () => history.push('/principal/hiring-requests');

  const handleLogoClick = () => history.push('/principal/candidates');

  const isOnCandidatesList = useRouteMatch('/principal/candidates')?.isExact;
  const isOnHiringRequests = useRouteMatch('/principal/hiring-requests')?.isExact;

  return (
    <NavbarContainer data-testid={ATSPrincipalAppNavbarTestIds.DESKTOP_NAVBAR}>
      <Box>
        <TextButton>
          <img
            onClick={handleLogoClick}
            src={logo}
            height="36px"
            width="132px"
            style={{ marginRight: theme.spacing(4) }}
          />
        </TextButton>
        <TextButton
          dataTestId={ATSPrincipalAppNavbarTestIds.CANDIDATES_LINK}
          onClick={handleCandidatesClick}
          sx={{
            fontSize: theme.typography.heading7.fontSize,
            borderRadius: theme.spacing(0.75),
            backgroundColor: isOnCandidatesList ? theme.palette.gray.lightest : 'inherit',
            marginRight: theme.spacing(1),
          }}
        >
          Candidates
        </TextButton>
        {auth.hasConnectIntegrationModule() && (
          <TextButton
            onClick={handleHiringRequestsClick}
            dataTestId={ATSPrincipalAppNavbarTestIds.HIRING_REQUESTS_LINK}
            sx={{
              fontSize: theme.typography.heading7.fontSize,
              borderRadius: theme.spacing(0.75),
              backgroundColor: isOnHiringRequests ? theme.palette.gray.lightest : 'inherit',
            }}
          >
            Connect Hiring Requests
          </TextButton>
        )}
      </Box>
      <UserDropdownMenu />
    </NavbarContainer>
  );
};
